module.exports = __webpack_public_path__ + "public/img/login_banner.46df51fc.png";